module.exports = __webpack_public_path__ + "static/mambo-logo-footer.c909d386.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mambo-logo-footer.svg
// module id = 842
// module chunks = 168707334958949